<template>
  <div v-if="showMode" class="rzfxClass onePictureDialog dy3dDialog">
    <div class="headerClass">
      <div class="headerTitle">
        <span>日照分析</span>
      </div>
      <div class="boxClose">
        <img
          :src="require('@/assets/images/poscloseIcon.png')"
          style="cursor: pointer"
          @click="close()"
        />
      </div>
    </div>
    <img class="splitLine" :src="require('@/assets/images/splitlineIcon.png')" />
    <div class="content">
      <a-row>
        <a-col :span="7">日期：</a-col>
        <a-col :span="16">
          <a-date-picker v-model="dateChoose" format="YYYY-MM-DD" :allowClear="false" @change="onDateChange"/>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="7">时间：</a-col>
        <a-col :span="16">
          <a-slider v-model="dateInput" :min="0" :max="1440" :step="1" @change="onTimeChange"/>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="7">当前时间：</a-col>
        <a-col :span="16" style="display:flex; align-items:center">
          <span style="color:#fff; margin-right:10px">{{ shadowDate }} {{ shadowTime }}</span>
          <a-icon :type="ifPlaying ? 'pause-circle' : 'play-circle'" :title="ifPlaying ? '暂停' : '播放'" style="color:#fff" @click="playOrStop" />
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "sunlightAnalysisDialog",
  data() {
    return {
      showMode: false,
      dateChoose: moment('2023-09-26'),//时间选择器
      dateInput: 420,//时间滑块
      shadowDate: '2023-09-26',
      shadowTime: '07:00',
      ifPlaying: false, // 是否正在播放
    };
  },
  methods: {
    open(map){
      this.map = map
      this.showMode = true
      this.shadows = new mars3d.thing.Shadows({
        multiplier: 1600
      })
      this.map.addThing(this.shadows)
      const that = this
      this.shadows.on(mars3d.EventType.change, function (e) {
        that.dateInput = Number(Math.floor((that.shadows.time.getTime() - new Date(that.dateChoose.format('YYYY-MM-DD') + " 00:00:00").getTime()) / 60000.0))
        if(that.dateInput >= 1439){
          that.dateInput = 0
          that.ifPlaying = false
        }
        that.shadowTime = Math.floor(that.dateInput / 60).toString().padStart(2, '0') + ':' + (that.dateInput % 60).toString().padStart(2, '0');
      })
    },
    // 修改日期
    onDateChange(value){
      this.shadowDate = value.format('YYYY-MM-DD')
    },
    // 修改时间
    onTimeChange(value){
      this.shadowTime = Math.floor(value / 60).toString().padStart(2,'0') + ':' + (value % 60).toString().padStart(2,'0')
    },
    // 播放
    playOrStop(){
      this.ifPlaying = !this.ifPlaying
      if(this.ifPlaying){
        let time = this.dateChoose.format('YYYY-MM-DD') + " " + this.shadowTime
        const dateTime = new Date(time)
        this.shadows.time = dateTime

        const currentTime = dateTime
        const startDate = new Date(this.dateChoose.format('YYYY-MM-DD') + " 00:00:00")
        const endDate = new Date(this.dateChoose.format('YYYY-MM-DD') + " 23:59:59")
        this.shadows.multiplier = 1600
        this.shadows.start(startDate, endDate, currentTime)
      }else {
        if (this.shadows && this.shadows.isStart) {
          this.shadows.pause()
        }
      }
    },
    // 关闭
    close(){
      if(this.map && this.shadows){
        this.map.removeThing(this.shadows)
      }
      this.ifPlaying = false
      this.showMode = false
    },
  },
};
</script>

<style lang="less" scoped>
.rzfxClass {
  position: absolute;
  top: 7%;
  right: 0.5%;
  width: 320px;
  height: 190px;
  border-radius: 4px;
  backdrop-filter: blur(15px);
  display: flex;
  flex-direction: column;
  .headerClass {
    position: relative;
    .headerTitle span {
      color: #fff;
    }
  }
  .splitLine {
    margin: 10px 0;
  }
  .content {
    height: calc(100% - 59px);
    .ant-row {
      display: flex;
      align-items: center;
      height: 32px;
      margin-bottom: 10px;
      /deep/ .ant-col:first-child {
        color: #fff;
        text-align: right;
      }
    }
  }
}
</style>